import templateUrl from "emun.invoice/credit-request/credit-request-container.htm";
import listTemplateUrl from "emun.invoice/credit-request/credit-request-list.htm";
import controller from "emun.invoice/credit-request/credit-request-container.controller";

const isList = (type = "") => type === "list" || type === "mutli-view";

export default {
  bindings: {
    ngModel: "=?",
    retailerId: "<?",
    invoiceId: "<?",
    creditRequestId: "<?",
    criteria: "<?",
    hideHeader: "<?",
    disableQueryString: "<?",
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      (isList($attrs.type) ? listTemplateUrl : templateUrl)
    );
  },
};
